import { getZeffyContactLink } from "@simplyk/common";

import { useLocaleContext } from "../../common/contexts/LocaleContext";

import { NewTabLink } from "./Link/NewTabLink";

import { useTranslate } from "@/common/hooks/useTranslate";

export const ContactSupportLink = () => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  return <NewTabLink href={getZeffyContactLink(locale)}>{t("dashboard", "common.ContactSupport")}</NewTabLink>;
};
